import React from 'react';
import { HomeOutlined, AppstoreOutlined, DatabaseOutlined, RocketOutlined, DesktopOutlined, ShoppingCartOutlined, RobotOutlined, ShopOutlined } from '@ant-design/icons';

export interface NavItem {
  icon?: React.ReactElement;
  label: string;
  path: string;
  submenu?: NavItem[];
  isAction?: boolean; // Para distinguir acciones como "New Project"
}

export const navigationItems: NavItem[] = [
  { icon: <HomeOutlined />, label: 'Overview', path: '/dashboard' },
  { 
    icon: <DatabaseOutlined />, 
    label: 'Infrastructure', 
    path: '/resources',
    submenu: [
      { icon: <RocketOutlined />, label: 'Deploy Apps', path: '/deploy-apps' },
      { icon: <DesktopOutlined />, label: 'Virtual Machines', path: '/virtual-machines' },
      { icon: <DatabaseOutlined />, label: 'Databases', path: '/databases' },
      { icon: <RobotOutlined />, label: 'Chatbot IA', path: '/chatbot-ia' },
    ]
  },
  { icon: <ShopOutlined />, label: 'Marketplace', path: '/marketplace' },
  { icon: <ShoppingCartOutlined />, label: 'Orders', path: '/orders' },
];